import { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AppProviders } from "@/context/AppProviders";
import { LocaleLayout } from "@/components/routing/LocaleLayout";
import { LocaleRedirect } from "@/components/routing/LocaleRedirect";
import { GoogleAnalytics } from "@/components/analytics/GoogleAnalytics";
import { OpenAIPixel } from "@/components/analytics/OpenAIPixel";
import { ScrollToTop } from "@/components/routing/ScrollToTop";
import { SiteHeader } from "@/components/layout/SiteHeader";

const HomePage = lazy(() =>
  import("@/pages/HomePage").then((module) => ({ default: module.HomePage }))
);
const AboutPage = lazy(() =>
  import("@/pages/AboutPage").then((module) => ({ default: module.AboutPage }))
);
const ContactPage = lazy(() =>
  import("@/pages/ContactPage").then((module) => ({ default: module.ContactPage }))
);
const PricingPage = lazy(() =>
  import("@/pages/PricingPage").then((module) => ({ default: module.PricingPage }))
);
const PrivacyPage = lazy(() =>
  import("@/pages/PrivacyPage").then((module) => ({ default: module.PrivacyPage }))
);
const TermsPage = lazy(() =>
  import("@/pages/TermsPage").then((module) => ({ default: module.TermsPage }))
);
const ServicePage = lazy(() =>
  import("@/pages/ServicePage").then((module) => ({ default: module.ServicePage }))
);
const BlogListPage = lazy(() =>
  import("@/pages/BlogListPage").then((module) => ({ default: module.BlogListPage }))
);
const BlogPostPage = lazy(() =>
  import("@/pages/BlogPostPage").then((module) => ({ default: module.BlogPostPage }))
);
const TagPage = lazy(() =>
  import("@/pages/TagPage").then((module) => ({ default: module.TagPage }))
);
const NotFoundPage = lazy(() =>
  import("@/pages/NotFoundPage").then((module) => ({ default: module.NotFoundPage }))
);
const TrustFeaturesSection = lazy(() =>
  import("@/components/layout/TrustFeaturesSection").then((module) => ({
    default: module.TrustFeaturesSection,
  }))
);
const SiteFooter = lazy(() =>
  import("@/components/layout/SiteFooter").then((module) => ({ default: module.SiteFooter }))
);

export default function App() {
  return (
    <AppProviders>
      <BrowserRouter>
        <GoogleAnalytics />
        <OpenAIPixel />
        <ScrollToTop />
        <div className="flex min-h-screen flex-col">
          <SiteHeader />
          <main className="flex-1">
            <Suspense fallback={null}>
              <Routes>
                <Route path="/" element={<LocaleRedirect />} />
                <Route path="/tr" element={<LocaleLayout locale="tr" />}>
                  <Route index element={<HomePage />} />
                  <Route path="servisler/:serviceSlug" element={<ServicePage />} />
                  <Route path="servisler/:serviceSlug/:featureSlug" element={<ServicePage />} />
                  <Route path="iletisim" element={<ContactPage />} />
                  <Route path="hakkimizda" element={<AboutPage />} />
                  <Route path="fiyatlandirma" element={<PricingPage />} />
                  <Route path="gizlilik" element={<PrivacyPage />} />
                  <Route path="kullanim-sozlesmesi" element={<TermsPage />} />
                  <Route path="blog" element={<BlogListPage />} />
                  <Route path="blog/kategori/:categorySlug" element={<BlogListPage />} />
                  <Route path="blog/:slug" element={<BlogPostPage />} />
                  <Route path="tag/:tagSlug" element={<TagPage />} />
                  <Route path="*" element={<NotFoundPage />} />
                </Route>
                <Route path="/en" element={<LocaleLayout locale="en" />}>
                  <Route index element={<HomePage />} />
                  <Route path="services/:serviceSlug" element={<ServicePage />} />
                  <Route path="services/:serviceSlug/:featureSlug" element={<ServicePage />} />
                  <Route path="contact" element={<ContactPage />} />
                  <Route path="about" element={<AboutPage />} />
                  <Route path="pricing" element={<PricingPage />} />
                  <Route path="privacy" element={<PrivacyPage />} />
                  <Route path="terms" element={<TermsPage />} />
                  <Route path="*" element={<NotFoundPage />} />
                </Route>
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </Suspense>
          </main>
          <Suspense fallback={null}>
            <TrustFeaturesSection />
            <SiteFooter />
          </Suspense>
        </div>
      </BrowserRouter>
    </AppProviders>
  );
}
